import {
  type AppConfig,
  type ConfigurationEnvironment,
  readBrowserConfig,
} from "@groundspark/browser-auth";

export type { AppConfig };

export function readConfig(
  environment: ConfigurationEnvironment = import.meta.env as ConfigurationEnvironment,
  currentLocation: Location = window.location,
): AppConfig {
  return readBrowserConfig(environment, currentLocation);
}
